export const verificationTranslations = {
  VERIFICATION_SUCCESS_TITLE: 'Je account is geverifieerd!',
  VERIFICATION_SUCCESS_SUBTITLE: 'Je bent nu een echte persoon in Tranzer. Je kunt nu je reis plannen, tickets kopen en de rit maken.',

  VERIFICATION_ERROR_TITLE: 'Account verificatie mislukt.',
  VERIFICATION_ERROR_SUBTITLE: 'We hebben je zojuist een nieuwe link gestuurd. Check je mailbox en probeer het nogmaals.',
};
